import { ElementRef, ViewChild, Directive } from '@angular/core';
import { AbstractControl, FormGroup, NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import momentImported from 'moment';
import { FormRequest } from '../../models/details/form-request';
import { FormResponse } from '../../models/details/form-response';
import { FormSaveResponse } from '../../models/details/form-save-response';
import { NotificationTypeEnum } from '../../models/notifications/notification-record';
import { BaseComponentContext } from '../../services/base-component-context.service';
import { BaseComponent } from '../base-component/base-component.component';
import { WafFormHelper } from '../../helpers/waf-form-helper';
// import { BaseComponentContext } from '../../services/base-component-context.service/base-component-context.service';
// import { BaseComponent } from '../base-component/base-component';
// import { WafFormHelper } from '../../helpers/waf-form-helper';


const moment = momentImported;

@Directive()
export abstract class BaseDetails<TFormRequest extends FormRequest, TFormResponse extends FormResponse<any>, TFormSaveResponse extends FormSaveResponse = FormSaveResponse> extends BaseComponent<TFormRequest, TFormResponse>{
    
    @ViewChild(NgForm) public ngForm: NgForm;

    @ViewChild(NgForm, { read: ElementRef })
    public ngFormElementRef: ElementRef

    protected originalForm: any;

    protected createRequestModel(): TFormRequest {
            return {} as any;
    }

    protected formSaveResponse: TFormSaveResponse;

    constructor(protected override componentContext: BaseComponentContext, protected override route: ActivatedRoute) {
            super(componentContext, route);
        this.replaceHistoryOnRequestModelChanged = true;
    }

    protected abstract getUserConfirmationOnExitAsync(): Promise<boolean>;

    public save(options?: any) {
    
        if (this.isLoading) {
                return;
        }

        if (this.ngForm) {
                if (!this.ngForm.valid) {
                    this.invalidateForm();
            } else {
    
                this.processSaveAsync(options).then((response) => {
                        if (response) {
                            this.requestModel = this.buildRequestModelFromFormSaveResponse(response);

                        this.refresh();
                    };
                });

            }
        }
    }

    public saveAndExit(options?: any) {
    
        if (this.isLoading) {
                return;
        }

        if (this.ngForm) {
                if (!this.ngForm.valid) {
                    this.invalidateForm();
            } else {
    
                this.processSaveAsync(options).then((response) => {
                        if (response) {
                            this.goBack(this.formSaveResponse);
                    };
                })

            }
        }
    }

    public back(skipCheck?: boolean) {
    
        if (!skipCheck && this.originalForm && this.viewModel.form != this.originalForm && JSON.stringify(this.viewModel.form) != JSON.stringify(this.originalForm)) {
                this.getUserConfirmationOnExitAsync().then((isConfirmed) => {
                    if (isConfirmed === true) {
                        this.goBack(this.formSaveResponse);
                }
            });
        }
        else {
                this.goBack(this.formSaveResponse);
        }
    }

    protected buildRequestModelFromFormSaveResponse(saveResponse: TFormSaveResponse): TFormRequest {
            return { id: saveResponse.id } as TFormRequest;
    }

    protected override onViewModelChanged() {
            if (this.viewModel) {
                this.originalForm = JSON.parse(JSON.stringify(this.viewModel.form));
        }
    }

    protected invalidateForm() {
            WafFormHelper.invalidateForm(this.ngForm, this.ngFormElementRef.nativeElement, true);
    }

    protected async processSaveAsync(options?: any): Promise<TFormSaveResponse> {
            if (this.isLoading) {
                return null;
        }
        this.isLoading = true;

        let promise = new Promise<TFormSaveResponse>((resolve, reject) => {
                this.componentContext.http.postJsonAsync<TFormSaveResponse>(this.actionName, this.viewModel.form, null).then(async response => {
                    this.componentContext.notificationService.add({ message: `Record saved [${moment().format('L LTS')}].`, type: NotificationTypeEnum.Success });
                this.formSaveResponse = response;

                this.isLoading = false;

                try {
                        const onProcessSaveResult = this.onProcessSaveSuccess();

                    if (onProcessSaveResult instanceof Promise) {
                            await onProcessSaveResult;
                    }
                }
                catch (e) {
                        console.error(e);
                }
                finally {
                        resolve(response);
                }

            },
                error => {
                        this.isLoading = false;
                    reject(error);
                });
        });

        return promise;
    }

    protected onProcessSaveSuccess(): Promise<any> | void {
    
    }
}